import script from "./AdminEmpDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminEmpDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AdminEmpDetail.vue?vue&type=style&index=0&id=09bbc5b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09bbc5b4"]])

export default __exports__